import React from "react";
import { Dialog, DialogContent, Box, Typography, IconButton, Table, TableBody, alpha } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CategoryIcon from "@mui/icons-material/Category";
import UpdateProductFamilyForm from "../UpdateProductFamilyForm";

const ACCENT = "#1976d2";

const EditProductFamilyDialog = ({ pf, open, onClose, ...formProps }) => {
  if (!pf) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: 4, overflow: "hidden" } }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 3,
          py: 2,
          background: `linear-gradient(135deg, ${ACCENT} 0%, ${alpha(ACCENT, 0.75)} 100%)`,
          color: "#fff",
        }}
      >
        <Box display="flex" alignItems="center" gap={1.5}>
          <Box sx={{ width: 38, height: 38, borderRadius: "50%", bgcolor: "rgba(255,255,255,0.18)", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <CategoryIcon fontSize="small" />
          </Box>
          <Box>
            <Typography variant="subtitle1" fontWeight={700}>
              עריכת משפחת מוצר
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.9 }}>
              {pf.familyName}
            </Typography>
          </Box>
        </Box>
        <IconButton size="small" onClick={onClose} sx={{ color: "#fff" }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <DialogContent sx={{ bgcolor: "#fafafa", p: 3 }}>
        <Table>
          <TableBody>
            <UpdateProductFamilyForm pf={pf} onCancel={onClose} {...formProps} />
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  );
};

export default EditProductFamilyDialog;
